module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-item",
    on: {
      "click": _vm.readNotification
    }
  }, [_c('div', {
    staticClass: "notification-item-text notification-item-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.notification.data.title))]), _vm._v(" "), (_vm.readFlag) ? _c('div', {
    staticClass: "flag flag-yes"
  }, [_c('span', [_vm._v("Leido")])]) : _c('div', {
    staticClass: "flag flag-no"
  }, [_c('span', [_vm._v("No leido")])])]), _vm._v(" "), _c('span', {
    staticClass: "notification-item-text notification-item-msj"
  }, [_vm._v(_vm._s(_vm.notification.data.message))]), _vm._v(" "), _c('span', {
    staticClass: "notification-item-text notification-item-date"
  }, [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.notification.data.sended_at.date)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2036e734"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/NotificationItem.vue
// module id = 1858
// module chunks = 1